import { render, staticRenderFns } from "./BarometerCollection.vue?vue&type=template&id=48e2570a"
import script from "./BarometerCollection.vue?vue&type=script&lang=ts"
export * from "./BarometerCollection.vue?vue&type=script&lang=ts"
import style0 from "./BarometerCollection.vue?vue&type=style&index=0&id=48e2570a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports